export const nonPathogenicColors = {
  "All Residues": "blue",
  "Current Variant": "magenta",
};
